<div class="content">
    <caremoni-muti-screen [isScreens]="isScreens" [dpadX]="dpadX" [dpadY]="dpadY"></caremoni-muti-screen>
    <div class="component-container">
        <router-outlet></router-outlet>
    </div>
</div>